<template>
  <div class="f-ast f-v">
    <div class="t t-xl ta-c m-tx3 m-bx3">
      Spend <span v-emoji="`${listing.points_cost} ${pointsName} :${pointsConfig.emoji}:`" class="bold" /> to redeem <span class="bold">{{ listing.name }}</span>?
    </div>
    <div
      v-if="redeemPreview"
      class="f-ac f-jc"
    >
      <div class="br-12 b-1 of-h m-x3 p-x4 p-y4 w-100p w-max-220">
        <cdn-img
          :path="redeemPreview.path"
          :version="redeemPreview.version ?? 0"
          :extension="redeemPreview.extension ?? 'png'"
          class="w-max-85p d-b m-x-auto"
        />
      </div>
    </div>
    <donut-modal-sections-actions
      button-text="Redeem"
      save-action="rewardsListings/redeemListing"
      :save-args="saveArgs"
    />
  </div>
</template>

<script setup>
  import { computed } from 'vue';
  import { useStore } from 'vuex';

  const redeemModalPreviewByMachineName = {
    donut_emoji_kit: {
      path: 'graphics/donut-emoji-kit-preview',
      version: 0,
    },
  };

  const { state } = useStore();

  const listing = computed(() => state.modal.data.listing);
  const pointsConfig = computed(() => state.modal.data.pointsConfig);
  const pointsName = computed(() => {
    if (listing.value.points_cost === 1) {
      return pointsConfig.value.points_name;
    }
    return pointsConfig.value.points_name_plural;
  });

  const saveArgs = computed(() => ({
    pointsConfig: pointsConfig.value,
    listing: listing.value,
  }));

  const redeemPreview = computed(() => {
    const machineName = listing.value?.machine_name;
    if (!machineName) return null;
    return redeemModalPreviewByMachineName[machineName] ?? null;
  });
</script>
